import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import OsagoDTO from '../../../../dto/OsagoDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';

export default function OsagoForm(props) {
  const { control, formMeta } = props;
  const dto = new OsagoDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_external_id}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_osago_series}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_osago_number}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          changeFormat="YYYY-MM-DD"
          onChangeToIso
          withLabel
          hideTime
          dtoObject={attributes.vehicle_osago_valid_from_date}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          changeFormat="YYYY-MM-DD"
          onChangeToIso
          withLabel
          hideTime
          dtoObject={attributes.vehicle_osago_valid_until_date}
          variant="material"
        />
      </Row>
    </>
  );
}
